/**
 * Limits an array to a maximum size by either keeping the first N items or last N items.
 *
 * @param array - The input array to limit
 * @param maxSize - The maximum number of items to keep
 * @param keepFromEnd - If true, keeps the last N items. If false, keeps the first N items. Defaults to true.
 * @returns A new array limited to maxSize items
 *
 * @example
 * // Keep last 2 items
 * limitArraySize([1,2,3,4], 2) // Returns [3,4]
 *
 * @example
 * // Keep first 2 items
 * limitArraySize([1,2,3,4], 2, false) // Returns [1,2]
 */
export const limitArraySize = <T extends Array<unknown>>(
  array: T,
  maxSize: number,
  keepFromEnd = true,
) => {
  if (array.length <= maxSize) {
    return array
  } else if (keepFromEnd) {
    return array.slice(-maxSize) as T // Keep last maxSize items
  } else {
    return array.slice(0, maxSize) as T // Keep first maxSize items
  }
}
